export const VALIDATION_MODE = {
  onChange: 'onChange',
  onSubmit: 'onSubmit'
};
